import { connect } from 'react-redux'

import {
  selectIsAddingNote,
  selectIsReplyingOrForwarding,
  selectIsForwarding,
} from 'selectors/page'

import { selectShouldUseDraftsV2, selectShouldUseNotesV2 } from 'selectors/app'
import {
  selectIsTwitterTicket,
  selectIsFacebookTicket,
} from 'selectors/tickets/type'

import { doChangeEditorFocus } from 'ducks/editor'
import {
  selectShowKbSearchOnInboxEditor,
  selectPrefersClassicView,
} from 'ducks/currentUser/selectors'

import Footer from './view'

const perform = dispatch => {
  return {
    onEditorFormFocus: () => dispatch(doChangeEditorFocus(true)),
    onEditorFormBlur: () => dispatch(doChangeEditorFocus(false)),
  }
}

const select = state => ({
  isReplyFormVisible: selectIsReplyingOrForwarding(state),
  isAddingNote: selectIsAddingNote(state),
  isForwarding: selectIsForwarding(state),
  showKbSearchOnInboxEditor: selectShowKbSearchOnInboxEditor(state),
  useDraftsV2: selectShouldUseDraftsV2(state),
  useNotesV2: selectShouldUseNotesV2(state),
  isTwitter: selectIsTwitterTicket(state),
  isFacebook: selectIsFacebookTicket(state),
  is3ColumnView: selectPrefersClassicView(state),
})

export default connect(select, perform)(Footer)
